module.exports = __webpack_public_path__ + "img/pic6.06e7e997.png";